import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { candidatesQueryKeys } from "./query-keys";

import type {
  ApplyFiltersData,
  UseApplyFiltersParams,
} from "@/features/integrations/modules/applies/api";
import { instance } from "@/lib/axios/instance";

export type CandidateFiltersData = Omit<ApplyFiltersData, "applicationSourceType">;

export function useCandidateFilters(
  params: UseApplyFiltersParams,
): UseQueryResult<CandidateFiltersData, AxiosError> {
  return useQuery({
    queryKey: candidatesQueryKeys.filterCounts(params),
    queryFn: () =>
      instance
        .get<CandidateFiltersData>("/api/v2/Candidates/FilterCounts", { params })
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
